export const SUCCESS = {
    SET_ACTIVE : 'SUCCESS_SET_ACTIVE',
};
